import React from "react";
import ReactDOM from "react-dom/client";
import 'bootstrap/dist/css/bootstrap.css';
import "./styles/main.scss"
import { Amplify } from "aws-amplify";
import outputs from "../amplify_outputs.json";
import AppRouter from "AppRouter.tsx";
import { Provider } from "react-redux";
import { store } from "store";

Amplify.configure({
  ...outputs,
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <AppRouter />
    </Provider>
  </React.StrictMode>
);